module.exports = __webpack_public_path__ + "static/media/infinity_color_big.d6353d7d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/icons/infinity_color_big.png
// module id = ./src/assets/media/icons/infinity_color_big.png
// module chunks = 16